import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { BrightNess } from '../../../Data/Types'
import VisibilityResultsImage from './VisibilityResultImage'
interface VisibilityResultsProps {
	brightness: BrightNess
}
const VisibilityResults: React.FC<VisibilityResultsProps> = ({
	brightness,
}) => {
	const { unit, value } = brightness
	return (
		<Flex
			height={'11rem'}
			flexDir="column"
			ml={{
				base: 0,
				md: '-2rem',
			}}
			align="center"
			// width={{ base: '10rem', md: '14.375rem' }}
		>
			<Heading
				display={{
					base: 'none',
					md: 'initial',
				}}
				mb=".5rem"
				size="lg"
			>
				Visibility
			</Heading>
			<Box>
				<VisibilityResultsImage
					visibility={
						value > 100 ? (value > 250 ? 'bright' : 'visible') : 'not visible'
					}
				/>
			</Box>
			<Box textAlign={'center'} mt={6}>
				<Text
					fontWeight={'bold'}
					fontSize={'xl'}
				>{`${value} ${unit.toUpperCase()}`}</Text>
				<Text> 80W</Text>
			</Box>
		</Flex>
	)
}

export default VisibilityResults
